export default {
	"lineManage": {
		"city": "เมือง",
		"lineName": "ชื่อเส้นทาง",
		"station": "กรุณาเลือกสถานที่",
		"lineCode": "รหัสเส้นทาง",
		"lineType": "ประเภทของเส้นทาง",
		"point": "จุด",
		"lineInfo": "ข้อมูลเส้นทาง",
		"defaultStartDt": "เวลาออกเดินทางเริ่มต้น",
		"stationNameFilter": "ฟิลเตอร์ชื่อสถานที่",
		"index": "ลำดับการสั่งซื้อ",
		"addLineTitle": "เพิ่มเส้นทาง",
		"importSiteTitle": "นำเข้าเส้นทาง",
		"fixedLineTitle": "ระบุเส้นทางแบบเจาะจง"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/lineManage/lineManage.js